// extracted by mini-css-extract-plugin
export default {"Popup":"Popup_Popup__2MPKh","Popup_entered":"Popup_Popup_entered__LPdjg","Popup__close":"Popup_Popup__close__w3Pa2"};